export enum ProducMenu {
  edit,
  createForm,
  delete,
  showJSON
}
